<template>
  <div class="progress">
    <div
        v-for="(answer, key) in sortedAnswers"
        v-tooltip="getTitle(answer)"
        class="progress-bar"
        role="progressbar"
        aria-valuemin="0"
        aria-valuemax="100"
        :aria-valuenow="answer.percentage_numeric"
        :style="calculateStyle(answer, key)"
    />
  </div>
</template>

<script>

export default {
  name: 'SelectOneQuestionResultBar',
  props: {
    answers: { required: true },
    question: { required: true },
  },

  computed: {

    sortedAnswers () {
      function compare (a, b) {
        if (parseInt(a.answer) < parseInt(b.answer)) { return 1 }
        if (parseInt(a.answer) > parseInt(b.answer)) { return -1 }
        return 0
      }

      return [...this.answers].sort(compare)
    },
    colors () {
      return ['#d9d8e1',
        '#bebbd0',
        '#b0abc7',
        '#9e98bc',
        '#8881af',
        '#746ba3',
        '#625898',
        '#4e438c',
        '#3e3182',
        '#251672']
    },

  },
  methods: {

    getTitle (answer) {
      return answer.answer + ' <br /> ' + answer.percentage
    },

    calculateStyle (answer, key) {
      return `width:${answer.percentage_numeric}%; background-color:${this.colors[key % 10]}`
    },
  },
}
</script>

<style scoped>
.progress {
  display: -webkit-box
}
</style>
